module.exports = __webpack_public_path__ + "img/logo.77c36e00.png";